import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PurchaseSuccessComponent } from './purchase-success.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { QRCodeModule } from 'angularx-qrcode';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    QRCodeModule
  ],
  declarations: [PurchaseSuccessComponent],
  exports: [PurchaseSuccessComponent]
})
export class PurchaseSuccessModule { }
